<template>
	<div
		class="spec-features"
		:class="{ 'spec-features--categories' : showCategory }"
	>
		<div v-if="showCategory" class="spec-item__category hide-mobile">
			Features
		</div>
		<div class="spec-features__list">
			<features-icons
				:build-parts="variantParts"
				:features="compatibilityFeatures"
			/>
		</div>
	</div>
</template>

<script>
import FeaturesIcons from "@c/store/features-icons";
import Icons from "@c/store/features-icons/icons";

export default {
	name: "SpecFeaturesItems",
	components: {
		FeaturesIcons
	},
	props: {
		showCategory: {
			type: Boolean,
			required: true
		},
		variantParts: {
			type: Object,
			default() {
				return {};
			}
		}
	},
	data() {
		return {
			compatibilityFeatures: [
				Icons("lighting"),
				Icons("wifi"),
				Icons("bluetooth"),
				Icons("usbc"),
				Icons("vr"),
				Icons("streaming")
			]
		};
	}
};
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.spec-features {
	width: 100%;
	display: flex;
	align-items: center;
	border-bottom: none;

	@media (min-width: 991px) {
		border-bottom: solid 2px #444259;
	}

	&__list {
		width: 100%;
		padding-top: 30px;

		@media (min-width: 991px) and (max-width: 1200px) {
			padding: 45px 15px 45px 15px;
		}

		@media (min-width: 1200px) {
			padding: 45px 30px 45px 15px;
		}
	}

	.hide-mobile {
		display: none;

		@media (min-width: 991px) {
			display: block;
		}
	}
}

.spec-features--categories {
	.spec-features__list {
		@media (min-width: 991px) and (max-width: 1200px) {
			padding: 45px 15px 45px 0;
		}

		@media (min-width: 1200px) {
			padding: 45px 30px 45px 0;
		}
	}
}

.spec-features::v-deep {
	.help-tooltip {
		min-width: 300px;
		padding: 15px;
		transform: translate(-80%, -160%);
	}

	.features-icons {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		max-width: 330px;
		margin: 0 auto;

		@media (min-width: 991px) {
			flex-wrap: nowrap;
			margin: 0 auto;
		}

		.icon {
			width: 95px;
			text-align: center;
			margin-bottom: 35px;

			&:nth-child(1n + 4) {
				@media (max-width: 580px) {
					margin-bottom: 0;
				}
			}

			@media (min-width: 991px) {
				width: auto;
				margin-bottom: 0;
			}

			&__text {
				font-size: 14px;
				color: $oldpurple;
				margin: 0;

				@media (min-width: 991px) {
					display: none;
				}
			}
		}
	}
}
</style>
